const DEFAULT_LABELS = {
  "components.shoppingBag.printTypes.paper": "Premium poster",
  "components.shoppingBag.printTypes.acryl": "Print op acrylglas",
  "components.shoppingBag.printTypes.aluminium": "Aluminium print",
  "components.shoppingBag.printTypes.tile": "Handgebakken tegeltje",
  "components.shoppingBag.frames.black": "Zwarte lijst",
  "components.shoppingBag.frames.oak": "Eiken lijst",
  "components.shoppingBag.frames.white": "Witte lijst",
};

export function getShoppingBagSummary(
  PosterSize,
  PrintType,
  PosterFrame,
  AcrylBlock,
  t = (key) => DEFAULT_LABELS[key] || key,
) {
  // --- Print type ---
  let printText = "";
  switch (PrintType) {
    case "paper":
      printText = t("components.shoppingBag.printTypes.paper");
      break;
    case "acryl":
      printText = t("components.shoppingBag.printTypes.acryl");
      break;
    case "aluminium":
      printText = t("components.shoppingBag.printTypes.aluminium");
      break;
    case "tegel":
      printText = t("components.shoppingBag.printTypes.tile");
      break;
  }

  const bagPrintTypeEl = document.querySelector(".js-bag-print-type");
  if (bagPrintTypeEl) bagPrintTypeEl.textContent = printText;

  // --- Poster size ---
  let printSize = "";
  const printPriceEl = document.querySelector(
    ".js-poster-size .js-size-option.active small[print-price]",
  );
  const printPrice = printPriceEl ? printPriceEl.textContent : "";

  if (PrintType === "tegel") {
    printSize = "(13x13cm)";
  } else {
    switch (PosterSize) {
      case "xs":
        printSize = "XS (15x21cm)";
        break;
      case "small":
        printSize = "S (21x30cm)";
        break;
      case "medium":
        printSize = "M (30x40cm)";
        break;
      case "large":
        printSize = "L (50x70cm)";
        break;
      case "extra-large":
        printSize = "XL (60x90cm)";
        break;
    }
  }

  const bagPrintSizeEl = document.querySelector(".js-bag-poster-size");
  if (bagPrintSizeEl) {
    bagPrintSizeEl.innerHTML = `${printSize} <span class="float-end">${printPrice}</span>`;
  }

  // --- Poster frame / block ---
  let accessoryText = "";

  if (["tegel", "acryl", "aluminium"].includes(PrintType)) {
    // Read block option label and price from the DOM
    if (AcrylBlock !== "no-block") {
      const blockSelector = `.js-toggle-for-material[data-material="${PrintType}"] .js-block-option[data-block="${AcrylBlock}"]`;
      const blockEl = document.querySelector(blockSelector);

      if (blockEl) {
        const blockLabel = blockEl.querySelector("strong")?.textContent || "";
        const blockPrice = blockEl.querySelector(".js-block-price, small")?.textContent || "";
        accessoryText = `${blockLabel} <span class='float-end'>${blockPrice}</span>`;
      }
    }
  } else {
    const accessoryPriceEl = document.querySelector(
      ".js-poster-frame .active small[frame-price]",
    );
    const accessoryPrice = accessoryPriceEl ? accessoryPriceEl.textContent : "";

    switch (PosterFrame) {
      case "black":
        accessoryText = t("components.shoppingBag.frames.black");
        break;
      case "oak":
        accessoryText = t("components.shoppingBag.frames.oak");
        break;
      case "white":
        accessoryText = t("components.shoppingBag.frames.white");
        break;
    }

    accessoryText += ` <span class='float-end'>${accessoryPrice}</span>`;
  }

  const accessoryEl = document.querySelector(".js-accessory");
  if (accessoryEl) accessoryEl.innerHTML = accessoryText;
}
